/**
 * 患者状态值对象
 *
 * @module patient-management/domain/valueObjects
 */

/**
 * 患者状态枚举
 */
export enum PatientStatus {
  ACTIVE = "active", // 活跃
  INACTIVE = "inactive", // 非活跃
  ARCHIVED = "archived", // 已归档
  DECEASED = "deceased", // 已故
}

/**
 * 患者状态显示文本
 */
export const PATIENT_STATUS_TEXT: Record<PatientStatus, string> = {
  [PatientStatus.ACTIVE]: "活跃",
  [PatientStatus.INACTIVE]: "非活跃",
  [PatientStatus.ARCHIVED]: "已归档",
  [PatientStatus.DECEASED]: "已故",
};

/**
 * 患者状态颜色
 */
export const PATIENT_STATUS_COLOR: Record<PatientStatus, string> = {
  [PatientStatus.ACTIVE]: "#52c41a",
  [PatientStatus.INACTIVE]: "#faad14",
  [PatientStatus.ARCHIVED]: "#8c8c8c",
  [PatientStatus.DECEASED]: "#ff4d4f",
};

/**
 * 获取患者状态标签
 */
export function getPatientStatusLabel(status: PatientStatus): string {
  return PATIENT_STATUS_TEXT[status] || "未知";
}

/**
 * 获取患者状态颜色
 */
export function getPatientStatusColor(status: PatientStatus): string {
  return PATIENT_STATUS_COLOR[status] || "#8c8c8c";
}
